<template>
  <div v-if="relatie">
    <b-alert
      v-if="error"
      show
      variant="danger"
      dismissible
      @dismissed="error = null"
    >
      {{ error }}<br>
      <b-button
        size="sm"
        variant="danger"
        @click="error = null"
      >
        Sluiten
      </b-button>
    </b-alert>
    
    <b-table
      :caption="`/relatie/${$route.params.id}/contactpersonen`"
      :items="relatie.Contactpersonen"
      :fields="fields"
      bordered
      small
    >
      <template #cell(Naam)="data">
        {{ data.item.Naam }} <i
          v-if="(data.item.Notitie || '').length > 0"
          class=" fa fa-sticky-note"
        />
        <!-- if user is beheerder -->
      </template>

      <template #cell(Email)="data">
        <a :href="`mailto:${data.item.Email}`">{{ data.item.Email }}</a>
      </template>

      <template
        #cell(Menu)="data"
      >
        <b-button 
          variant="info" 
          size="sm" 
          @click="openKlanttoegang(data.item)"
        >
          Klanttoegang
        </b-button>
        <b-button
          variant="danger"
          class="mx-2"
          size="sm"
          @click="deleteContactpersoon = data.item"
        >
          Verwijderen
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          class="mx-2"
          @click="onRowSelected(data.item)"
        >
          Bewerken
        </b-button>
        <b-button 
          size="sm" 
          variant="warning"
          :disabled="!isBeheerder || (data.item.Rol && data.item.Rol.includes('Klant'))"
          @click="requestPasswordReset(data.item.Id)" 
        >
          Wachtwoord instellen
        </b-button>
      </template>
    </b-table>

    <KlanttoegangsModal
      v-model="showKlanttoegangsModal"
      :contactpersoon="selectedContactpersoonForKlanttoegang"
      :relatie-id="Number($route.params.id)"
      @saved="onKlanttoegangsaved"
    />

    <!-- reset password link modal -->
    <b-modal 
      v-if="passwordResetData" 
      :visible="passwordResetData != null"
      @hide="passwordResetData = null"
    >
      <template #modal-title>
        Omleiding instellen wachtwoord
      </template>
      <b-button 
        variant="outline-primary"
        size="lg"  
        @click="openWindowResetPassword()"
      >
        <u>Klik hier om het nieuwe wachtwoord in te stellen</u>
      </b-button><br>
      <small>Deze link is 30 minuten geldig</small>
      <template #modal-footer>
        <b-button 
          variant="primary" 
          @click="passwordResetData = null"
        >
          Annuleren
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-if="deleteContactpersoon"
      :visible="deleteContactpersoon != null"
      title="Contactpersoon verwijderen?"
      @hide="deleteContactpersoon = null"
      @ok="onDeleteSelected(deleteContactpersoon)"
    >
      <b-form-group label="Naam">
        <b-form-input
          v-model="deleteContactpersoon.Naam"
          readonly
          placeholder="Naam"
        />
      </b-form-group>
      <b-form-group label="Telefoon">
        <b-form-input
          v-model="deleteContactpersoon.Telefoon"
          readonly
          placeholder="Telefoonnummer"
        />
      </b-form-group>
      <b-form-group label="Mobiel">
        <b-form-input
          v-model="deleteContactpersoon.Mobiel"
          readonly
          placeholder="Mobiel"
        />
      </b-form-group>
      <b-form-group label="E-mail">
        <b-form-input
          v-model="deleteContactpersoon.Email"
          placeholder="E-mailadres"
          readonly
        />
      </b-form-group>
    </b-modal>

    <b-modal
      v-model="edit"
      :title="isNieuw ? 'Nieuw contactpersoon' : 'Contactpersoon bewerken'"
      @ok="onOkModal"
      @cancel="edit = false"
    >
      <b-form-group label="Naam">
        <b-form-input
          v-model="contactpersoon.naam"
          placeholder="Naam"
        />
      </b-form-group>
      <b-form-group label="Functie">
        <b-input
          v-model="contactpersoon.functie"
          placeholder="Functie omschrijving"
          maxlength="64"
        />
      </b-form-group>
      <b-form-group label="Telefoon">
        <b-form-input
          v-model="contactpersoon.telefoon"
          placeholder="Telefoonnummer"
        />
      </b-form-group>
      <b-form-group label="Mobiel">
        <b-form-input
          v-model="contactpersoon.mobiel"
          placeholder="Mobiel"
        />
      </b-form-group>
      <b-form-group label="E-mail">
        <b-form-input
          v-model="contactpersoon.email"
          placeholder="E-mailadres"
        />
      </b-form-group>
      <b-form-group label="Rol">
        <b-select
          v-model="contactpersoon.rol"
          :options="[
            { text: 'Geen', value: null },
            { text: 'Inspecteur', value: 'Inspecteur' },
            { text: 'Hoofdinspecteur', value: 'Hoofdinspecteur' },
            {
              text: 'Hoofdinspecteur+',
              value: 'Hoofdinspecteur,Administratief',
            },
            { text: 'Keuringsinstituut', value: 'Keuringsinstituut' },
            { text: 'Klant', value: 'Klant' },
            { text: 'Klantrelatie', value: 'Klantrelatie' },
            { text: 'Onderhoud', value: 'Onderhoud' },
          ]"
        />
      </b-form-group>
      <b-form-group label="Notitie">
        <b-textarea
          v-model="contactpersoon.notitie"
          max-rows="8"
          maxlength="512"
        />
      </b-form-group>
    </b-modal>

    <b-button
      variant="success"
      @click="startNieuweContactpersoon"
    >
      <i class="fa fa-plus" /> Nieuwe contactpersoon
    </b-button>
  </div>
</template>

<script>
import KlanttoegangsModal from "@/components/KlanttoegangsModal.vue";
import { serviceMixin } from "@/mixins/serviceMixin";

export default {
  components: {
    KlanttoegangsModal,
  },
  mixins: [serviceMixin],
  props: {
    relatie: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      passwordResetData: null,
      showKlanttoegangsModal: false,
      selectedContactpersoonForKlanttoegang: null,
      error: null,
      contactpersoon: {
        naam: null,
        email: null,
        telefoon: null,
        rol: null,
        functie: null,
        notitie: null,
        id: null
      },
      selectedRef: null,
      edit: false,
      deleteContactpersoon: null,
      fields: [
        { key: "Naam" },
        { key: "Functie" },
        { key: "Email", label: "E-mail" },
        { key: "Rol" },
        { key: "Telefoon" },
        { key: "Mobiel" },
        { key: "Menu" }
      ],
    };
  },
  computed: {
    baseApiUrl: function() {
      return this.$http.defaults.baseURL;
    },
    passwordResetLink: function() {
      if (this.passwordResetData && this.passwordResetData.token) {
        var adminPage = '/admin/password_reset/?token=';
        return this.$http.defaults.baseURL.replace('/index.cfm',adminPage);
      }
      return null;
    },
    isNieuw: function() {
      return !this.contactpersoon.id || false;
    },
    isBeheerder: function() {
      return (this.$store.getters.user.roles || '').split(",").includes('Beheerder');
    },
  },
  methods: {
    openWindowResetPassword() {
      if (this.passwordResetData && this.passwordResetData.token) {
        const url = this.passwordResetLink + this.passwordResetData.token;
        window.open(url, '_blank');
        this.passwordResetData = null;
      }
    },
    openKlanttoegang(contactpersoon) {
      this.selectedContactpersoonForKlanttoegang = contactpersoon;
      this.showKlanttoegangsModal = true;
    },
    onKlanttoegangsaved() {
      this.$bvToast.toast('Klanttoegang succesvol opgeslagen', {
        title: 'Opgeslagen',
        variant: 'success',
        solid: true
      });
    },
    requestPasswordReset(id) {
      var vm = this;
      this.post('/user/password_reset_token', {userid:id}).then((resp) => 
      {
        vm.passwordResetData = resp.data;
      }).catch(function(error) {
        console.dir(error);
        vm.error = error.response.data;
        // vm.error = error;
      });
    },
    onRowSelected(item) {
      console.dir(item);
      this.selectedRef = item;
      this.contactpersoon = {
        naam: item.Naam,
        email: item.Email,
        telefoon: item.Telefoon,
        rol: item.Rol,
        mobiel: item.Mobiel,
        id: item.Id,
        functie: item.Functie,
        notitie: item.Notitie
      };
      this.edit = true;
    },
    onDeleteSelected(item) {
      var index = this.relatie.Contactpersonen.indexOf(item);
      var vm = this;
      this.error = null;
      console.log("deleteUser");
      this.$http.delete(`/relatie/${this.$route.params.id}/contactpersonen`, { data: { contactpersoonid: this.deleteContactpersoon.Id } })
        .then(function(response) {
          console.dir(response.data);
          vm.relatie.Contactpersonen.splice(index, 1);
        })
        .catch(function (error) {
          vm.error = error.response.data;
          // vm.error = error;
        });
    },
    startNieuweContactpersoon() {
      this.contactpersoon = {
        naam: null,
        email: null,
        telefoon: null,
        rol: null,
        id: null,
        functie: null,
        notitie: null
      }
      this.edit = true;
    },
    onOkModal() {
      this.isNieuw ? this.createUser() : this.updateUser();
    },
    createUser() {
      var vm = this;
      console.log("createUser");
      this.post(`/relatie/${this.$route.params.id}/contactpersonen`, { contactpersoon: this.contactpersoon }).then(function(response) {
        vm.relatie.Contactpersonen.push(response.data.contactpersoon);
      })
      .catch(function(error) {
        console.log(error);
      });
    },
    updateUser() {
      console.log("updateUser");
      var vm = this;
      this.put(`/relatie/${this.$route.params.id}/contactpersonen`, { contactpersoon: this.contactpersoon, contactpersoonId: this.contactpersoon.id }).then(function(response) {
        vm.selectedRef = response.data.contactpersoon;
        vm.$set(vm.relatie.Contactpersonen, vm.relatie.Contactpersonen.map(c => c.Id).indexOf(vm.contactpersoon.id), response.data.contactpersoon)
      })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
};

</script>